import {
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import { message } from 'antd';
import { fetchDashboard } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';
import * as tabsActions from '@store/dashboards/tabs/actions';

import * as actions from './actions';
import * as types from './types';
import { configSelector } from './selectors';

function* afterRequest() {
  const state = yield select(configSelector);
  if (!state) {
    return;
  }
  yield put(tabsActions.triggerChangeTabs(state, state.id));
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* getConfig({ id }) {
  yield actions.fetching();
  try {
    yield autoRequest(fetchDashboard, types.SCOPE, id, afterRequest);
  } catch (error) {
    message.error(error.message);
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchGetConfig() {
  yield takeLatest([
    types.GET_CONFIG,
  ], getConfig);
}

export default [
  watchInitRequest,
  watchGetConfig,
];
